<template>
  <v-card>
    <v-card-text class="headline text-xs-center secondary--text pb-0">Editar Imagem de Convênio</v-card-text>
    <v-stepper class="elevation-0" v-model="step">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex
                class="text-xs-center title primary--text"
              >Insira uma imagem 500x500 ao convênio {{convenio.nome_convenio}}?</v-flex>
              <v-flex align-self-center>
                <img v-if="imagem_convenio || convenio.url_imagem_codigo != null"
                  max-height="400"
                  max-width="400"
                  :src="imagem_convenio ? dados_convenio.url_imagem_codigo: convenio.url_imagem_codigo"
                  @click="imagem_convenio ? carregarImagem = true : $refs.imageInput.click()"
                  style="cursor: pointer"
                />
                <v-card v-else  color="grey" height="250" width="250"
                 @click="imagem_convenio ? carregarImagem = true : $refs.imageInput.click()">
                  <v-layout justify-center align-center fill-height>
                    <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex class="text-xs-center">
                <v-btn
                  flat
                  block
                  color="grey darken-2"
                  @click="$refs.imageInput.click()"
                >
                  <v-spacer></v-spacer>
                  <template v-if="nome_imagem">{{nome_imagem}}</template>
                  <template v-else>CARREGAR IMAGEM</template>
                  <v-spacer></v-spacer>
                  <v-icon>cloud_upload</v-icon>
                  <input
                    type="file"
                    style="display:none"
                    accept="image/*"
                    ref="imageInput"
                    @input="carregarImagem"
                  />
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-card-actions>
      <v-btn flat color="grey darken-2" @click="voltar()">
        CANCELAR
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="green" @click="concluirInsercao()" :loading="loading">
        CONCLUIR
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  props: ['convenio_posto'],
  data () {
    return {
      step: 1,
      convenio: null,
      imagem_convenio: null,
      nome_imagem: null,
      dados_convenio: {
        url_imagem_codigo: null
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    carregarImagem (event) {
      this.imagem_convenio = null
      let file = event.target.files[0]
      let reader = new FileReader()
      reader.onload = event => {
        var image = new Image()
        image.src = event.target.result
        var self = this
        image.onload = function (e) {
          var height = this.height
          var width = this.width
          if (height !== 400 || width !== 400) {
            const canvas = document.createElement('canvas')
            const maxWidth = 400
            const scaleSize = maxWidth / width
            canvas.width = maxWidth
            canvas.height = height * scaleSize
            if (canvas.height > 400) {
              const scaleSize = maxWidth / canvas.height
              canvas.height = maxWidth
              canvas.width = canvas.height * scaleSize
            }
            const ctx = canvas.getContext('2d')
            ctx.drawImage(e.target, 0, 0, canvas.width, canvas.height)
            const srcEncoded = ctx.canvas.toDataURL(e.target, 'image/jpeg')
            self.dados_convenio.url_imagem_codigo = srcEncoded
            self.imagem_convenio = srcEncoded
            self.nome_imagem = file.name
            return true
          }
          self.dados_convenio.url_imagem_codigo = event.target.result
          self.imagem_convenio = event.target.result
          self.nome_imagem = file.name
          return true
        }
      }
      if (file) {
        reader.readAsDataURL(file)
      }
    },
    voltar () {
      this.imagem_convenio = null
      this.dados_convenio.url_imagem_codigo = null
      this.nome_imagem = null
      this.$emit('edicao_fechar')
    },
    concluirInsercao () {
      if (this.imagem_convenio != null) {
        this.$store.dispatch('inserirBannerStorage', {
          prefixo: 'convenio',
          id: this.convenio_posto.id,
          imagem: this.imagem_convenio
        }).then(downloadUrl => {
          this.convenio_posto.convenio.url_imagem_codigo = downloadUrl
          this.$store.dispatch('atualizarConvenio', {
            id: this.convenio_posto.id,
            data: {
              ...this.convenio_posto,
              url_imagem_codigo: downloadUrl
            }
          }).then(() => {
            this.step = 1
            this.voltar()
            this.$emit('concluir')
          })
        })
      } else {
        alert('Você não inseriu uma imagem')
      }
    }
  },
  beforeMount () {
    if (this.convenio_posto) {
      this.convenio = this.convenio_posto.convenio
    }
  }
}
</script>
